import PropTypes from "prop-types";
import React from "react";
import { Grid } from "@mui/material";
import UnselectedList from "./UnselectedList";
import SelectedList from "./SelectedList";

const DualList = ({
  unselectedList,
  selectedList,
  onAddAll,
  onRemoveAll,
  onAddToSelectedList,
  onAddToUnselectedList,
  selectedListHeader,
  unselectedListHeader,
  selectedListAction,
  unselectedListAction,
  removeAllButtonText,
  hideAddAllButton,
  hideRemoveAllButton,
  disabled,
  renderList
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <UnselectedList
          items={unselectedList}
          onAddToSelectedList={onAddToSelectedList}
          onAddAll={onAddAll}
          header={unselectedListHeader}
          listAction={unselectedListAction}
          hideAddAllButton={hideAddAllButton}
          disabled={disabled}
          renderList={renderList}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <SelectedList
          listAction={selectedListAction}
          header={selectedListHeader}
          items={selectedList}
          onAddToUnselectedList={onAddToUnselectedList}
          onRemoveAll={onRemoveAll}
          removeAllButtonText={removeAllButtonText}
          hideRemoveAllButton={hideRemoveAllButton}
          disabled={disabled}
          renderList={renderList}
        />
      </Grid>
    </Grid>
  );
};

export default DualList;

DualList.propTypes = {
  unselectedListHeader: PropTypes.string,
  selectedListHeader: PropTypes.string,
  equivalenceHelperMessage: PropTypes.string,
  onAddToUnselectedList: PropTypes.func,
  onAddToSelectedList: PropTypes.func,
  onAddAll: PropTypes.func,
  onRemoveAll: PropTypes.func,
  selectedList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      subtitles: PropTypes.arrayOf(PropTypes.string),
      highlighted: PropTypes.bool
    })
  ),
  unselectedList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      subtitles: PropTypes.arrayOf(PropTypes.string),
      highlighted: PropTypes.bool
    })
  ),
  unselectedListAction: PropTypes.node,
  hideAddAllButton: PropTypes.bool,
  hideRemoveAllButton: PropTypes.bool,
  disabled: PropTypes.bool
};
